import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Avatar, Button, Space, Input } from '@sinohealth/butterfly-ui-components';
import useChatGpt, { config } from './useChatGpt';
import { InfoCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import cls from 'classnames';
import styles from './index.less';
import request from '@/common/request';
import lodash from 'lodash';

const { TextArea } = Input;
type ChatGptWindowProps = {}

const colorData = [
  '#EDB392',
  '#FF7F50',
  '#C76079',
  '#32CD32',
  '#C76079',
  '#E5B8C3',
  '#7582D3',
  '#937ECD',
];
const ChatDemo: React.FC<ChatGptWindowProps> = (props: ChatGptWindowProps) => {
  const [messageText, setMessageText] = useState('');
  const [tips, setTips] = useState([]);
  const chatBody = useRef(null);
  const chatGpt = useChatGpt({
    formUnionId: 'props.formUnionId',
  });
  useEffect(() => {
    // @ts-ignore
    chatBody.current && (chatBody.current.scrollTop = chatBody.current.scrollHeight);
  }, [chatGpt.msgList]);

  useEffect(() => {
    fetchTips('');
  }, []);

  const fetchTips = useCallback(lodash.debounce((question: string) => {
    request.post('/chat-demo/chat/completion', {
      question,
    }).then((res: any) => {
      const text = ['的不良反应', '的适应症状'];
      setTips(res.map((name: string) => {
        return name + text[Math.floor(Math.random() * 2)];
      }));
    });
  }, 1000), []);

  const renderItem = (msgItem: any) => {
    const catItemClassName = cls({
      [styles.chatItem]: true,
      [styles.self]: msgItem.isSelf,
    });
    return (
      <div className={catItemClassName}>
        <Avatar className={styles.avatar} size="large" src={msgItem.avatar} />
        <div className={styles.chatContent}>
          <div className={styles.name}>
            {msgItem.name}
            {/* <span>{msgItem.createTime}</span> */}
          </div>
          <div className={styles.content}>
            {msgItem.message}
          </div>
          {
            msgItem.isError && (
              <div className={styles.error} onClick={() => (msgItem.reset && msgItem.reset())}>
                <ReloadOutlined style={{ fontSize: '14px' }} /> 重新发送
              </div>
            )
          }
        </div>
      </div>
    );
  };

  const isDisabled = chatGpt.isError || chatGpt.isFinished || chatGpt.loading;
  const handleSendMsg = (text = '') => {
    if (isDisabled) {
      return;
    }
    chatGpt.sendMessage(text || messageText);
    setTimeout(() => {
      setMessageText('');
      setTips([]);
      fetchTips('');
    }, 100);
  };
  const onInput = (e: any) => {
    fetchTips(e.target.value);
    setMessageText(e.target.value);
  };
  const getRandomColor = () => {
    const c = colorData[Math.floor(Math.random() * colorData.length)];
    return { backgroundColor: c, borderColor: c, color: '#fff' };
    // return { color: c, borderColor: c };
  };
  const tipsDom = useMemo(() => {
    return tips.map((text) => (
      <div className={styles.tipItem} style={getRandomColor()} onClick={() => handleSendMsg(text)}>{text}</div>
    ));
  }, [tips]);
  return (
    <div className={styles.page}>
      <div className={styles.chatGptWindow}>
        <div className={styles.header}>AI智能药师</div>
        {
          chatGpt.isError && (
            <div className={styles.errorBox}>
              <span><InfoCircleOutlined /> &nbsp;&nbsp;网络繁忙，请稍后重试！</span>
            </div>
          )
        }
        <div className={styles.chatBody} ref={chatBody}>
          {chatGpt.msgList.map(renderItem)}
          {
            chatGpt.loading && (
              <div className={styles.chatItem}>
                <Avatar className={styles.avatar} size="large" src={config.aiInfo.avatar} />
                <div className={styles.chatContent}>
                  <div className={styles.name}>
                    {config.aiInfo.name}
                    {/* <span>{msgItem.createTime}</span> */}
                  </div>
                  <div className={styles.content}>
                    <img className={styles.aiLoading} src={config.aiLoading} alt="loading..." />
                  </div>
                </div>
              </div>
            )
          }
        </div>
        <div className={styles.chatFooter}>
          <div className={styles.tip}>
            {
              tipsDom
            }
          </div>
          {
            !chatGpt.isFinished && (
              <TextArea onPressEnter={() => !chatGpt.loading && handleSendMsg()} onChange={onInput} value={messageText} autoSize={{ minRows: 3, maxRows: 3 }} bordered={false} placeholder="请在此处输入问题…" />
            )
          }
          {/* <div className={styles.action}> */}
          {/*  <Space> */}
          {/*    <Button onClick={() => {}} style={{ background: '#0000000d', color: '#00000073', border: 'none', fontWeight: 400 }}>重新开始</Button> */}
          {/*    { */}
          {/*      !chatGpt.isFinished && ( */}
          {/*        <Button type="primary" disabled={isDisabled || messageText.trim() === ''} onClick={handleSendMsg}>发送</Button> */}
          {/*      ) */}
          {/*    } */}
          {/*  </Space> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default ChatDemo;
